/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useState, useEffect, useCallback } from 'react';
import { useSnackbar } from 'notistack';

import { getStorageValue } from 'utils/localStorage';

import { getNotificationAPI, updateNotificationAPI } from '../../../api';

import { iComunication, iUpdateModalParams } from '../types';

export const useComunicatiosHooks = () => {
  const { enqueueSnackbar } = useSnackbar();

  const clientId = getStorageValue<string>('@pdamodules::codigoCliente');

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

  const [comunicationData, setComunicationData] = useState<iComunication[]>([]);

  const [currentIndex, setCurrentIndex] = useState(0);

  const hasPrev = currentIndex > 0;
  const hasNext = comunicationData.length - 1 > currentIndex;

  const handlePrev = () => {
    if (hasPrev) setCurrentIndex(prev => prev - 1);
  };

  const handleNext = () => {
    if (hasNext) setCurrentIndex(prev => prev + 1);
  };

  const handleClosesModal = async () => {
    try {
      await handleUpdateNotification();
      sessionStorage.setItem('pda_comm_seen', 'true');
    } catch {
      enqueueSnackbar('Erro inesperado', { variant: 'error' });
    } finally {
      setIsOpenModal(false);
    }
  };

  const handleUpdateNotification = async () => {
    try {
      setIsLoading(true);
      const filterData: iComunication[] = comunicationData.filter(
        p => p.disableCheckBox === true
      );

      if (!filterData.length) {
        enqueueSnackbar('Todas as mensagens serão exibidas novamente!', {
          variant: 'warning',
        });

        return;
      }

      if (filterData.length !== comunicationData.length) {
        enqueueSnackbar('Algumas mensagens serão exibidas novamente.', {
          variant: 'warning',
        });
      }

      await Promise.all(
        filterData.map((p: iComunication) => {
          const dataSend: iUpdateModalParams = {
            codigo: p.codigo,
            codigoCliente: Number(clientId),
            codigoStatus: 1,
          };

          return updateNotificationAPI(dataSend);
        })
      );
    } catch (error) {
      enqueueSnackbar('Erro ao atualizar informações!', {
        variant: 'warning',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleiGreeNotification = (code: number) => {
    try {
      setComunicationData(prevState => {
        return prevState.map(p =>
          p.codigo === code ? { ...p, disableCheckBox: true } : { ...p }
        );
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };

  const handleDontGreeNotification = (code: number) => {
    try {
      setComunicationData(prevState => {
        return prevState.map(p =>
          p.codigo === code ? { ...p, disableCheckBox: false } : { ...p }
        );
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };

  const handleGetModalData = useCallback(async () => {
    try {
      setIsLoading(true);

      const { data: response } = await getNotificationAPI(Number(clientId));

      if (!response.length) return;

      setComunicationData(response);
      setIsOpenModal(true);
    } catch (error) {
      enqueueSnackbar('Erro ao carregar dados do modal!', {
        variant: 'error',
      });
    } finally {
      setIsLoading(false);
    }
  }, [clientId, enqueueSnackbar]);

  useEffect(() => {
    const seen = sessionStorage.getItem('pda_comm_seen');
    if (seen === 'false') handleGetModalData();
  }, [handleGetModalData, clientId]);

  return {
    isLoading,
    isOpenModal,
    currentIndex,
    comunicationData,
    handlePrev,
    handleNext,
    handleClosesModal,
    handleGetModalData,
    handleiGreeNotification,
    handleDontGreeNotification,
    handleUpdateNotification,
  };
};
